'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdRouter = function MdRouter(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm25 30v-3.4h-3.4v3.4h3.4z m-5.9 0v-3.4h-3.2v3.4h3.2z m-5.7 0v-3.4h-3.4v3.4h3.4z m18.2-8.4c1.8 0 3.4 1.6 3.4 3.4v6.6c0 1.8-1.6 3.4-3.4 3.4h-23.2c-1.8 0-3.4-1.6-3.4-3.4v-6.6c0-1.8 1.6-3.4 3.4-3.4h16.6v-6.6h3.4v6.6h3.2z m0.6-10.4l-1.3 1.3c-1.2-1.2-2.8-1.6-4.3-1.6s-2.9 0.4-4.1 1.6l-1.3-1.3c1.5-1.5 3.4-2.4 5.4-2.4s4.1 0.9 5.6 2.4z m1.5-1.4c-2.1-1.8-4.6-2.8-7.1-2.8s-4.9 1-6.9 2.8l-1.3-1.3c2.3-2.3 5.3-3.5 8.2-3.5s6.1 1.2 8.4 3.5z' })
        )
    );
};

exports.default = MdRouter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/router.js
// module id = 3732
// module chunks = 168707334958949